/**
 * Dia operacional da loja, o mesmo da API (`StoreClock.OperationalDate`) e do
 * histórico do painel (`apps/panel/src/features/orders/utils/operational-day.ts`):
 * o horário do estabelecimento tem offset fixo de −3, e o dia vira às 03:00. A
 * busca de pedidos lê `from`/`to` nesse calendário, então o atalho "Hoje" das
 * 01:30 ainda é o dia anterior, como para o dono.
 */

const HOUR_MS = 3_600_000;
const DAY_MS = 24 * HOUR_MS;

/** Offset fixo do horário da loja em relação ao UTC, como o `StoreClock`. */
const STORE_UTC_OFFSET_HOURS = -3;

/** Hora local em que o dia operacional começa. */
const OPERATIONAL_DAY_START_HOUR = 3;

/** Data operacional (`YYYY-MM-DD`) do instante. */
export function operationalDate(instant: Date): string {
  const shifted = instant.getTime() + (STORE_UTC_OFFSET_HOURS - OPERATIONAL_DAY_START_HOUR) * HOUR_MS;
  return new Date(shifted).toISOString().slice(0, 10);
}

/** Soma dias a uma data `YYYY-MM-DD`, sem passar pelo fuso do navegador. */
export function addDays(date: string, days: number): string {
  const base = Date.parse(`${date}T00:00:00Z`);
  return new Date(base + days * DAY_MS).toISOString().slice(0, 10);
}
